<template>
    <div v-if="loading == false">
        <ChirpList
            :data_source="rows"
            :export_api="export_api"
            :totalCount="totalCount"
            :target_page="targetPage"
            @applyCriteria="modifyCriteria"
            :loadingColumns="loadingTable"
            :column_meta="columnMeta"
            :storeKey="storeKey"
            :useOverride="useOverride"
            @cancelOverride="handleCancelOverride"
        />
    </div>
    <div v-else>Loading...</div>
</template>

<script>
    import { tryGetFilter } from '@/util/tryGetFilter';

    const api_root = 'insurance/list_claims';

    import ChirpList from '@/components/general/list/ChirpList';

    export default {
        name: 'InsuranceClaims',
        components: { ChirpList },
        props: {
            overrideFilter: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                rows: [],
                totalCount: 0,
                targetPage: 'InsuranceClaimDetail',
                loading: true,
                loadingTable: false,
                useOverride: false,
                columnMeta: [
                    { field: 'claim_id', headerText: 'Internal Claim ID' },
                    { field: 'claim_number', headerText: 'Claim Number' },
                    { field: 'submission_date', headerText: 'Submission Date & Time' },
                    { field: 'client', headerText: 'Client' },
                    { field: 'payer', headerText: 'Payer' },
                    { field: 'claim_status', headerText: 'Status' },
                    { field: "total_charge", headerText: 'Total Charge', align: 'Left'},
                    { field: 'form_type', headerText: 'Form Type' },
                    { field: 'services', headerText: 'Services Associated (CPT)', align: 'Left'},
                ],
                criteriaProps: {},
                export_api: '/insurance/list_claims',
            };
        },
        computed: {
            criteria() {
                return this.useOverride && this.overrideFilter ? this.overrideCriteria : this.savedCriteria;
            },
            savedCriteria() {
                return tryGetFilter(this.$store, this.storeKey);
            },
            overrideCriteria() {
                return this.$store.getters['filters/overrideCriteria'](this.storeKey);
            },
            storeKey() {
                return this.pageMeta?.page || 'insurance-claims';
            },
        },
        methods: {
            async load_data() {
                try {
                    const body = {
                        criteria: this.criteria
                    };
                    const res = await this.$api.post(this.export_api, body);

                    if (res.status >= 400) {
                        this.$toasted.error('Failed to fetch insurance claim roster.');
                        return;
                    }

                    this.rows = res.data.rows;

                    this.totalCount = res.data.total_count;
                } catch (err) {
                    this.$toasted.error('Failed to fetch insurance claim roster.');
                }
                this.$nextTick(() => {
                    this.loading = false;
                });
            },
            async init() {
                if (this.overrideFilter) {
                    this.useOverride = true;
                    this.$store.commit('filters/applyOverride', {
                        stateKey: this.storeKey,
                        criteria: this.overrideFilter,
                    });
                }

                if (!this.criteria.sort || (this.criteria.sort && Object.keys(this.criteria.sort).length === 0)) {
                    this.$store.commit('filters/applyDefaultDateSort', {
                        stateKey: this.storeKey,
                        customDateKey: 'submission_date',
                    });
                }

                await this.load_data();
            },
            async modifyCriteria(criteria) {
                if (this.targetPage) {
                    this.$store.commit('filters/update', {
                        criteriaPage: this.targetPage,
                        payload: criteria,
                    });
                }
                this.criteriaProps = criteria;
                this.load_data();
            },
            handleCancelOverride() {
                this.useOverride = false;
            },
        },
        watch: {
            criteria: {
                deep: true,
                async handler() {
                    await this.load_data();
                },
            },
        },
        async created() {
            await this.init();
        },
    };
</script>
